import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/cre/Header";
import Footer from "@/components/cre/Footer";
import { Button } from "@/components/ui/button";
import { Ban } from "lucide-react";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen cre-grid-bg flex flex-col">
      <Header />
      <div className="flex-1 max-w-3xl mx-auto w-full px-6 md:px-8 py-16">
        <div
          data-testid="checkout-cancel-page"
          className="cre-surface rounded-sm p-8 md:p-10 text-center"
        >
          <Ban className="h-10 w-10 mx-auto text-slate-500" />
          <h1 className="mt-4 font-heading text-2xl font-bold">
            Checkout cancelled
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            No charge was made. You're still on the Free plan with{" "}
            <span className="font-mono">3</span> analyses per month.
          </p>
          <div className="mt-6 flex justify-center gap-2">
            <Button
              onClick={() => navigate("/dashboard")}
              data-testid="checkout-cancel-dashboard-btn"
            >
              Back to dashboard
            </Button>
            <Link to="/" className="hidden md:inline">
              <Button variant="outline">Home</Button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
